import { render, staticRenderFns } from "./detail-teamer.vue?vue&type=template&id=b1db21bc&scoped=true&"
import script from "./detail-teamer.vue?vue&type=script&lang=js&"
export * from "./detail-teamer.vue?vue&type=script&lang=js&"
import style0 from "./detail-teamer.vue?vue&type=style&index=0&id=b1db21bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1db21bc",
  null
  
)

export default component.exports